// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__128J2","selected":"Chip_selected__1LWeV"};